import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { ClientPhotoCard } from '@cp/entities/clientPhoto';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import capitalize from 'lodash/capitalize';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { ClientsListProps } from './model';

export * from './model';

export const ClientsList: React.FC<ClientsListProps> = ({ clients, isLoading, onClientCardClick, emptyMessage, sx }) => {
  const theme = useTheme();

  if (isLoading) {
    return <ContentSkeleton blocks={3} />;
  }

  if (!clients?.length) {
    return (
      <Typography component="div" sx={mergeSx({ textAlign: 'center', color: 'gray', py: 10 }, sx)} variant="body">
        {emptyMessage ?? 'Ничего не найдено'}
      </Typography>
    );
  }

  return (
    <Stack direction="column" gap={1.5} sx={sx}>
      {clients.map((client) => (
        <Stack
          direction="row"
          key={client.id}
          onClick={(event) => onClientCardClick?.(client, event)}
          role="button"
          sx={{
            cursor: 'pointer',
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette['gray light']}`,
            borderRadius: '12px',
            p: 1.5,
            alignItems: 'center',
          }}
          tabIndex={0}
        >
          <ClientPhotoCard data={client} rounded size={48} />
          <Typography sx={{ ml: 1 }} variant="body bold">
            {capitalize(client.name)}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
